(function () {
  console.log('[BEYO FILTERS] Script loaded');

  var productsState = null;
  var filtersState = null;
  var onFiltersChange = null;

  /* ============================
   * FILTER CHIPS & SHEET
   * ============================ */

  var BEYO_I18N = null;

  function readI18n() {
    if (BEYO_I18N) return BEYO_I18N;
    var el = document.getElementById('beyo-i18n');
    if (!el) return (BEYO_I18N = {});
    try {
      return (BEYO_I18N = JSON.parse(el.textContent || '{}'));
    } catch (e) {
      console.warn('[BEYO FILTERS] Failed to parse #beyo-i18n JSON', e);
      return (BEYO_I18N = {});
    }
  }

  function t(path, fallback) {
    var dict = readI18n();
    var parts = String(path || '').split('.');
    var cur = dict;
    for (var i = 0; i < parts.length; i++) {
      cur = cur ? cur[parts[i]] : null;
    }
    if (typeof cur === 'string' && cur) return cur;
    return fallback != null ? fallback : path;
  }

  function applyI18n(root) {
    if (!root) return;

    var dict = readI18n();
    if (!dict) return;

    function getByPath(obj, path) {
      var parts = String(path || '').split('.');
      var cur = obj;
      for (var i = 0; i < parts.length; i++) {
        if (!cur || typeof cur !== 'object') return null;
        cur = cur[parts[i]];
      }
      return (cur == null) ? null : String(cur);
    }

    root.querySelectorAll('[data-beyo-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-beyo-i18n');
      var val = getByPath(dict, key);
      if (val != null) el.textContent = val;
    });

    root.querySelectorAll('[data-beyo-i18n-placeholder]').forEach(function (el) {
      var key = el.getAttribute('data-beyo-i18n-placeholder');
      var val = getByPath(dict, key);
      if (val != null) el.setAttribute('placeholder', val);
    });
  }

  function showProductsLoader(root) {
    var grid = root.querySelector('[data-beyo-products-grid]');
    if (!grid) return;

    var loader = grid.querySelector('[data-beyo-products-loader]');
    if (!loader) return;

    loader.classList.remove('is-hidden');
  }

  function hideProductsLoader(root) {
    var grid = root.querySelector('[data-beyo-products-grid]');
    if (!grid) return;

    var loader = grid.querySelector('[data-beyo-products-loader]');
    if (!loader) return;

    loader.classList.add('is-hidden');
  }


  function getStorefrontContext() {
    var langRaw =
      (document.documentElement.getAttribute('lang') || '') ||
      (window.Shopify && Shopify.locale) ||
      'en';

    var language = String(langRaw).split('-')[0].toUpperCase();
    var country = 'SE';

    return { language: language, country: country };
  }

  function initFiltersToggle(root) {
    var toggleBtn = root.querySelector('[data-beyo-filters-toggle]');
    var filtersAside = root.querySelector('.beyo-filters');
    var layout = root.querySelector('.beyo-collection__layout');

    if (!toggleBtn || !filtersAside || !layout) return;

    var hidden = false;

    function update() {
      if (hidden) {
        filtersAside.classList.add('beyo-filters--collapsed');
        layout.classList.add('beyo-collection__layout--filters-collapsed');
        toggleBtn.textContent = t('filters.show','Show filters');
        toggleBtn.classList.add('is-off');
      } else {
        filtersAside.classList.remove('beyo-filters--collapsed');
        layout.classList.remove('beyo-collection__layout--filters-collapsed');
        toggleBtn.textContent = t('filters.hide','Hide filters');
        toggleBtn.classList.remove('is-off');
      }
    }

    toggleBtn.addEventListener('click', function () {
      hidden = !hidden;
      update();
    });

    update();
  }

  function initFilterChips(root) {
    var chips = root.querySelectorAll('[data-beyo-filter-chip]');
    var panels = root.querySelectorAll('.beyo-filter-panel');
    var filters = root.querySelector('.beyo-filters');
    var backdrop = root.querySelector('.beyo-filters__backdrop');
    var sheetCloseBtn = root.querySelector('.beyo-filters__sheet-close');

    if (!chips.length || !filters) return;

    function setActiveFilter(key) {
      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', chip.dataset.beyoFilterChip === key);
      });

      if (key === 'all') {
        panels.forEach(function (panel) {
          panel.classList.add('is-visible');
        });
      } else {
        panels.forEach(function (panel) {
          var panelKey = panel.dataset.beyoFilterPanel;
          if (panelKey === key) {
            panel.classList.add('is-visible');
          } else {
            panel.classList.remove('is-visible');
          }
        });
      }
    }

    function openSheet(key) {
      setActiveFilter(key);
      filters.classList.add('beyo-filters--sheet-open');
      document.documentElement.classList.add('beyo-no-scroll');
    }

    function closeSheet() {
      filters.classList.remove('beyo-filters--sheet-open');
      document.documentElement.classList.remove('beyo-no-scroll');
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.dataset.beyoFilterChip;
        if (window.innerWidth <= 749) {
          openSheet(key);
        } else {
          setActiveFilter('all');
        }
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeSheet);
    }
    if (sheetCloseBtn) {
      sheetCloseBtn.addEventListener('click', closeSheet);
    }

    setActiveFilter('all');
  }

  /* ============================
   * RANGE SLIDERS
   * ============================ */

  function updateRangeProgress(groupEl) {
    var minVal = Number(groupEl.dataset.min || 0);
    var maxVal = Number(groupEl.dataset.max || 100);
    var inputMin = groupEl.querySelector('.beyo-range__input--min');
    var inputMax = groupEl.querySelector('.beyo-range__input--max');
    var progress = groupEl.querySelector('.beyo-range__progress');

    if (!inputMin || !inputMax || !progress) return;

    var vMin = Number(inputMin.value);
    var vMax = Number(inputMax.value);
    var range = maxVal - minVal || 1;

    var left = ((Math.min(vMin, vMax) - minVal) / range) * 100;
    var right = ((Math.max(vMin, vMax) - minVal) / range) * 100;

    progress.style.left = left + '%';
    progress.style.width = (right - left) + '%';
  }

  function initRange(groupEl) {
    var name = groupEl.dataset.beyoRange;
    var minVal = Number(groupEl.dataset.min || 0);
    var maxVal = Number(groupEl.dataset.max || 100);
    var step = Number(groupEl.dataset.step || 1);

    var inputMin = groupEl.querySelector('.beyo-range__input--min');
    var inputMax = groupEl.querySelector('.beyo-range__input--max');
    var progress = groupEl.querySelector('.beyo-range__progress');

    var root = groupEl.closest('#beyo-collection-root') || document;
    var numMin = root.querySelector('[data-beyo-range-min-input="' + name + '"]');
    var numMax = root.querySelector('[data-beyo-range-max-input="' + name + '"]');

    if (!inputMin || !inputMax || !progress) return;

    groupEl.dataset.defaultMin = String(minVal);
    groupEl.dataset.defaultMax = String(maxVal);

    [inputMin, inputMax].forEach(function (r) {
      r.min = String(minVal);
      r.max = String(maxVal);
      r.step = String(step);
    });

    inputMin.value = String(minVal);
    inputMax.value = String(maxVal);

    if (numMin) numMin.value = String(minVal);
    if (numMax) numMax.value = String(maxVal);

    function clamp(val) {
      if (isNaN(val)) return minVal;
      return Math.min(Math.max(val, minVal), maxVal);
    }

    function syncFromRange(e, triggerFilters) {
      var vMin = Number(inputMin.value);
      var vMax = Number(inputMax.value);

      if (vMin > vMax) {
        if (e && e.target === inputMin) {
          vMax = vMin;
          inputMax.value = String(vMax);
        } else {
          vMin = vMax;
          inputMin.value = String(vMin);
        }
      }

      if (numMin) numMin.value = String(vMin);
      if (numMax) numMax.value = String(vMax);

      updateRangeProgress(groupEl);

      if (triggerFilters && typeof onFiltersChange === 'function') {
        onFiltersChange();
      }
    }

    function readNumOrNull(el) {
      if (!el) return null;
      var s = String(el.value || '').trim();
      if (!s) return null;
      var v = parseFloat(s);
      return isNaN(v) ? null : v;
    }

    function clampOr(val, fallback) {
      if (val == null || isNaN(val)) return fallback;
      return Math.min(Math.max(val, minVal), maxVal);
    }

    function syncFromNumber(e) {
      var rawMin = readNumOrNull(numMin);
      var rawMax = readNumOrNull(numMax);

      var curMin = Number(inputMin.value);
      var curMax = Number(inputMax.value);

      var vMin = clampOr(rawMin, curMin);
      var vMax = clampOr(rawMax, curMax);

      if (vMin > vMax) {
        if (e && e.target === numMin) {
          vMax = vMin;
        } else {
          vMin = vMax;
        }
      }

      inputMin.value = String(vMin);
      inputMax.value = String(vMax);

      if (numMin && rawMin != null) numMin.value = String(vMin);
      if (numMax && rawMax != null) numMax.value = String(vMax);

      updateRangeProgress(groupEl);
      if (typeof onFiltersChange === 'function') onFiltersChange();
    }

    inputMin.addEventListener('input', function (e) {
      syncFromRange(e, false);
    });
    inputMax.addEventListener('input', function (e) {
      syncFromRange(e, false);
    });

    inputMin.addEventListener('change', function (e) {
      syncFromRange(e, true);
    });
    inputMax.addEventListener('change', function (e) {
      syncFromRange(e, true);
    });


    if (numMin) numMin.addEventListener('input', syncFromNumber);
    if (numMax) numMax.addEventListener('input', syncFromNumber);

    updateRangeProgress(groupEl);
  }

  function resetRange(groupEl) {
    var minVal = Number(groupEl.dataset.defaultMin || groupEl.dataset.min || 0);
    var maxVal = Number(groupEl.dataset.defaultMax || groupEl.dataset.max || 100);

    var inputMin = groupEl.querySelector('.beyo-range__input--min');
    var inputMax = groupEl.querySelector('.beyo-range__input--max');

    var name = groupEl.dataset.beyoRange;
    var root = groupEl.closest('#beyo-collection-root') || document;
    var numMin = root.querySelector('[data-beyo-range-min-input="' + name + '"]');
    var numMax = root.querySelector('[data-beyo-range-max-input="' + name + '"]');

    if (!inputMin || !inputMax) return;

    inputMin.value = String(minVal);
    inputMax.value = String(maxVal);
    if (numMin) numMin.value = String(minVal);
    if (numMax) numMax.value = String(maxVal);

    updateRangeProgress(groupEl);
  }

  function initWoodTags(root) {
    var tags = root.querySelectorAll('[data-beyo-wood]');
    tags.forEach(function (tag) {
      tag.addEventListener('click', function () {
        if (tag.classList.contains('beyo-filter-tag--more')) {
          return;
        }
        tag.classList.toggle('is-selected');
        if (typeof onFiltersChange === 'function') onFiltersChange();
      });
    });
  }
  function initSetOfTags(root) {
    var tags = root.querySelectorAll('[data-beyo-setof]');
    tags.forEach(function (tag) {
      tag.addEventListener('click', function () {
        tag.classList.toggle('is-selected');
        if (typeof onFiltersChange === 'function') onFiltersChange();
      });
    });
  }

  function initClearButton(root) {
    var clearBtn = root.querySelector('.beyo-filters__clear');
    if (!clearBtn) return;

    clearBtn.addEventListener('click', function () {
      root.querySelectorAll('.beyo-filter-tag.is-selected').forEach(function (tag) {
        tag.classList.remove('is-selected');
      });

      root.querySelectorAll('[data-beyo-range]').forEach(function (groupEl) {
        resetRange(groupEl);
      });

      if (typeof onFiltersChange === 'function') onFiltersChange();
    });
  }

  /* ============================
   * Storefront API
   * ============================ */

  function storefrontFetch(root, query, variables) {
    var endpoint = root.getAttribute('data-storefront-endpoint');
    var token = root.getAttribute('data-storefront-token');

    if (!endpoint || !token) {
      console.warn('[BEYO FILTERS] Storefront endpoint/token not provided');
      return Promise.reject(new Error('Missing endpoint or token'));
    }

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Storefront HTTP error: ' + res.status);
      }
      return res.json();
    }).then(function (json) {
      if (json.errors) {
        console.error('[BEYO FILTERS] Storefront errors:', json.errors);
        throw new Error('Storefront GraphQL error');
      }
      return json.data;
    });
  }

  function parseWoodValue(rawValue) {
    if (rawValue == null) return [];
    var result = [];
    var raw = String(rawValue).trim();
    if (!raw) return result;

    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        parsed.forEach(function (v) {
          if (v != null && String(v).trim()) {
            result.push(String(v).trim());
          }
        });
      } else if (typeof parsed === 'string' || typeof parsed === 'number') {
        var s = String(parsed).trim();
        if (s) result.push(s);
      }
    } catch (e) {
      raw = raw.replace(/^\[/, '').replace(/\]$/, '').trim();

      raw.split(/[;,/|]/).forEach(function (part) {
        var v = part.trim();
        v = v.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '').trim();
        if (v) result.push(v);
      });
    }

    return result;
  }

  function parseSetOfValue(rawValue) {
    if (rawValue == null) return null;

    var raw = String(rawValue).trim();
    if (!raw) return null;

    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function loadProductsFromStorefront(root, handle, maxProducts) {
    var query = `
      query BeyoCollectionProducts(
        $handle: String!,
        $first: Int!,
        $after: String,
        $language: LanguageCode,
        $country: CountryCode
      ) @inContext(language: $language, country: $country) {
        collection(handle: $handle) {
          id
          title
          products(first: $first, after: $after) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                handle
                title
                availableForSale
                tags
                createdAt
                onlineStoreUrl
                totalInventory
                images(first: 20) {
                  edges {
                    node {
                      url(transform: { maxWidth: 900, preferredContentType: WEBP })
                      altText
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                }
                woodType: metafield(namespace: "custom", key: "wood_type") {
                  value
                }
                totalHeight: metafield(namespace: "custom", key: "totalheight") {
                  value
                }
                totalWidth: metafield(namespace: "custom", key: "totalwidth") {
                  value
                }
                totalDepth: metafield(namespace: "custom", key: "totaldepth") {
                  value
                }
                seatHeight: metafield(namespace: "custom", key: "seatheightchairs") {
                  value
                }
                setOf: metafield(namespace: "custom", key: "quantity") {
                  value
                }
              }
            }
          }
        }
      }
    `;

    var collectionHandle = root.getAttribute('data-collection-handle') || null;
    var pageSize = 250;
    var allProducts = [];
    var cursor = null;

    function mapEdge(edge) {
      var node = edge.node;

      var images = (node.images && node.images.edges)
        ? node.images.edges.map(function (e) {
            return e.node && e.node.url;
          }).filter(Boolean)
        : [];

      if (!images.length) {
        images = ['https://placehold.co/800x600?text=Beyo+Vintage'];
      }

      var price = 0;
      if (node.priceRange && node.priceRange.minVariantPrice) {
        price = parseFloat(node.priceRange.minVariantPrice.amount);
      }

      var compare = null;
      if (node.compareAtPriceRange && node.compareAtPriceRange.maxVariantPrice) {
        compare = parseFloat(node.compareAtPriceRange.maxVariantPrice.amount);
      }

      var woodArray = [];
      if (node.woodType && node.woodType.value) {
        var parsedList = parseWoodValue(node.woodType.value);
        parsedList.forEach(function (v) {
          var key = v.toLowerCase().trim();
          if (!key) return;
          woodArray.push(key);
        });
        woodArray = Array.from(new Set(woodArray));
      }

      function parseDim(mf) {
        if (!mf || mf.value == null) return null;
        var v = parseFloat(mf.value);
        return isNaN(v) ? null : v;
      }
      function getRoutesRoot() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      }
      var rootPath = getRoutesRoot();

      if (collectionHandle) {
        productUrl = rootPath + 'collections/' + collectionHandle + '/products/' + node.handle;
      } else {
        productUrl = rootPath + 'products/' + node.handle;
      }

      return {
        id: node.id,
        handle: node.handle,
        title: node.title,
        url: productUrl,
        images: images,
        price: price,
        compare_at_price: compare,
        created_at: new Date(node.createdAt),
        sold_count: node.totalInventory || 0,
        sold_out: !node.availableForSale,
        wood: woodArray,
        height: parseDim(node.totalHeight),
        width: parseDim(node.totalWidth),
        depth: parseDim(node.totalDepth),
        seat_height: parseDim(node.seatHeight),
        set_of: parseSetOfValue(node.setOf && node.setOf.value),
        tags: node.tags || []
      };
    }

    function fetchPage() {
      var ctx = getStorefrontContext();

      var variables = {
        handle: handle,
        first: pageSize,
        after: cursor,
        language: ctx.language,
        country: ctx.country
      };
      

      return storefrontFetch(root, query, variables).then(function (data) {
        if (!data || !data.collection || !data.collection.products) {
          console.warn('[BEYO FILTERS] No collection/products in response');
          return { done: true };
        }

        var connection = data.collection.products;
        var edges = connection.edges || [];

        edges.forEach(function (edge) {
          if (allProducts.length >= maxProducts) return;

          var mapped = mapEdge(edge);
          if (!mapped) return;

          var rawTags = edge.node.tags || [];
          var tags = rawTags.map(function (t) {
            return String(t).toLowerCase().trim();
          });

          var isOnline = tags.indexOf('online') !== -1;

          if (!isOnline) {
            return;
          }

          allProducts.push(mapped);
        });

        var hasNext = connection.pageInfo && connection.pageInfo.hasNextPage;
        var endCursor = connection.pageInfo && connection.pageInfo.endCursor;

        if (hasNext && endCursor && allProducts.length < maxProducts) {
          cursor = endCursor;
          return fetchPage();
        }

        return { done: true };
      });
    }

    return fetchPage().then(function () {
      console.log('[BEYO FILTERS] Loaded products:', allProducts.length);
      return allProducts;
    });
  }

  function formatMoney(num) {
    if (typeof num !== 'number' || isNaN(num)) return '';
    return num.toLocaleString('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' kr';
  }

  function isReservedProduct(p) {
    if (!p || !p.tags) return false;
    for (var i = 0; i < p.tags.length; i++) {
      if (String(p.tags[i]).toUpperCase().trim() === 'RESERVED') return true;
    }
    return false;
  }

  function sortProducts(products, sortBy) {
    var arr = products.slice();

    function reservedFirst(a, b) {
      var ar = isReservedProduct(a) ? 1 : 0;
      var br = isReservedProduct(b) ? 1 : 0;
      if (ar !== br) return br - ar;
      return 0;
    }

    arr.sort(function (a, b) {
      var r = reservedFirst(a, b);
      if (r !== 0) return r;

      switch (sortBy) {
        case 'price-asc':
          return a.price - b.price;

        case 'price-desc':
          return b.price - a.price;

        case 'title-asc':
          return a.title.localeCompare(b.title);

        case 'title-desc':
          return b.title.localeCompare(a.title);

        case 'date-asc': // old to new
          return a.created_at - b.created_at;

        case 'date-desc': // new to old
          return b.created_at - a.created_at;

        case 'best-selling':
          return b.sold_count - a.sold_count;

        case 'featured':
        default:
          return 0;
      }
    });

    return arr;
  }


  function applyFilters(products) {
    if (!filtersState) return products.slice();

    return products.filter(function (p) {
      // price
      if (filtersState.priceMin != null && !isNaN(filtersState.priceMin) && p.price < filtersState.priceMin) {
        return false;
      }
      if (filtersState.priceMax != null && !isNaN(filtersState.priceMax) && p.price > filtersState.priceMax) {
        return false;
      }

      // wood
      if (filtersState.wood && filtersState.wood.size > 0) {
        var woodNorm = (p.wood || []).map(function (w) {
          return String(w).toLowerCase();
        });

        var hasAny = false;
        filtersState.wood.forEach(function (val) {
          if (woodNorm.indexOf(val) !== -1) {
            hasAny = true;
          }
        });

        if (!hasAny) return false;
      }

      if (filtersState.setOf && filtersState.setOf.size > 0) {
        var match = false;

        filtersState.setOf.forEach(function (val) {
          if (val >= 10) {
            if (p.set_of != null && p.set_of >= 10) {
              match = true;
            }
          } else {
            if (p.set_of === val) {
              match = true;
            }
          }
        });

        if (!match) return false;
      }

      function checkDim(dimValue, minVal, maxVal) {
        if (dimValue == null || isNaN(dimValue)) return true;
        if (minVal != null && !isNaN(minVal) && dimValue < minVal) return false;
        if (maxVal != null && !isNaN(maxVal) && dimValue > maxVal) return false;
        return true;
      }

      if (!checkDim(p.height, filtersState.heightMin, filtersState.heightMax)) return false;
      if (!checkDim(p.width, filtersState.widthMin, filtersState.widthMax)) return false;
      if (!checkDim(p.depth, filtersState.depthMin, filtersState.depthMax)) return false;

      if (filtersState.seatHeightMin != null || filtersState.seatHeightMax != null) {
        if (!checkDim(p.seat_height, filtersState.seatHeightMin, filtersState.seatHeightMax)) return false;
      }

      return true;
    });
  }

  function getPagedProducts(state) {
    var source = (state.filtered !== null && Array.isArray(state.filtered))
      ? state.filtered
      : state.all;

    var sorted = sortProducts(source, state.sortBy);
    var totalItems = sorted.length;
    var totalPages = Math.max(1, Math.ceil(totalItems / state.pageSize));
    var page = Math.min(Math.max(1, state.currentPage), totalPages);
    var start = (page - 1) * state.pageSize;
    var items = sorted.slice(start, start + state.pageSize);

    return {
      items: items,
      totalItems: totalItems,
      totalPages: totalPages,
      currentPage: page
    };
  }

  /* ============================
 * URL STATE (short keys)
 * ============================ */

  function hasNum(v) { return v != null && !isNaN(v); }

  function parseUrlState(isSeating) {
    var sp = new URLSearchParams(window.location.search);

    function num(key) {
      var v = sp.get(key);
      if (v == null || v === '') return null;
      var n = parseFloat(v);
      return isNaN(n) ? null : n;
    }

    function setFromCsv(key) {
      var raw = (sp.get(key) || '').trim();
      if (!raw) return new Set();
      return new Set(raw.split(',').map(function (x) { return String(x).toLowerCase().trim(); }).filter(Boolean));
    }

    function numSetFromCsv(key) {
      var raw = (sp.get(key) || '').trim();
      if (!raw) return new Set();

      return new Set(
        raw
          .split(',')
          .map(function (x) { return parseInt(String(x).trim(), 10); })
          .filter(function (x) { return !isNaN(x); })
      );
    }

    var page = parseInt(sp.get('page') || '1', 10);
    if (!page || page < 1) page = 1;

    var sort = (sp.get('sort') || '').trim();
    var allowedSort = new Set(['featured','best-selling','title-asc','title-desc','price-asc','price-desc','date-asc','date-desc']);
    if (!allowedSort.has(sort)) sort = null;

    var fs = {
      priceMin: num('priceMin'),
      priceMax: num('priceMax'),
      heightMin: num('heightMin'),
      heightMax: num('heightMax'),
      widthMin:  num('widthMin'),
      widthMax:  num('widthMax'),
      depthMin:  num('depthMin'),
      depthMax:  num('depthMax'),
      seatHeightMin: isSeating ? num('seatHeightMin') : null,
      seatHeightMax: isSeating ? num('seatHeightMax') : null,
      wood: setFromCsv('wood'),
      setOf: isSeating ? numSetFromCsv('setOf') : new Set()
    };

    return { page: page, sort: sort, filters: fs };
  }

  function writeUrlState(ps, fs, replace) {
    var sp = new URLSearchParams(window.location.search);

    // page
    if (ps.currentPage && ps.currentPage > 1) sp.set('page', String(ps.currentPage));
    else sp.delete('page');

    // sort
    if (ps.sortBy && ps.sortBy !== 'featured') sp.set('sort', ps.sortBy);
    else sp.delete('sort');

    // filters
    function setNum(key, val) {
      if (val == null || isNaN(val)) sp.delete(key);
      else sp.set(key, String(val));
    }
    function setSet(key, set) {
      if (!set || set.size === 0) sp.delete(key);
      else sp.set(key, Array.from(set).join(','));
    }

    setNum('priceMin', fs.priceMin);
    setNum('priceMax', fs.priceMax);

    setNum('heightMin', fs.heightMin);
    setNum('heightMax', fs.heightMax);

    setNum('widthMin',  fs.widthMin);
    setNum('widthMax',  fs.widthMax);

    setNum('depthMin',  fs.depthMin);
    setNum('depthMax',  fs.depthMax);

    setNum('seatHeightMin', fs.seatHeightMin);
    setNum('seatHeightMax', fs.seatHeightMax);

    setSet('wood', fs.wood);

    setSet('setOf', fs.setOf);

    var qs = sp.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    var st = { beyo: true, page: ps.currentPage, sort: ps.sortBy, filters: true };

    if (replace) history.replaceState(st, '', url);
    else history.pushState(st, '', url);
  }

  /** применить filtersState -> UI инпуты */
  function applyFiltersToUI(root, fs, isSeating) {
    function setInput(sel, val) {
      var el = root.querySelector(sel);
      if (!el) return;
      el.value = (val == null || isNaN(val)) ? '' : String(val);
    }

    // numbers
    setInput('[data-beyo-range-min-input="price"]', fs.priceMin);
    setInput('[data-beyo-range-max-input="price"]', fs.priceMax);

    setInput('[data-beyo-range-min-input="height"]', fs.heightMin);
    setInput('[data-beyo-range-max-input="height"]', fs.heightMax);

    setInput('[data-beyo-range-min-input="width"]', fs.widthMin);
    setInput('[data-beyo-range-max-input="width"]', fs.widthMax);

    setInput('[data-beyo-range-min-input="depth"]', fs.depthMin);
    setInput('[data-beyo-range-max-input="depth"]', fs.depthMax);

    if (isSeating) {
      setInput('[data-beyo-range-min-input="seatHeight"]', fs.seatHeightMin);
      setInput('[data-beyo-range-max-input="seatHeight"]', fs.seatHeightMax);
    }

    root.querySelectorAll('[data-beyo-wood]').forEach(function (tag) {
      var v = (tag.getAttribute('data-beyo-wood') || tag.textContent || '').toLowerCase().trim();
      tag.classList.toggle('is-selected', fs.wood && fs.wood.has(v));
    });

    root.querySelectorAll('[data-beyo-setof]').forEach(function (tag) {
      var v = parseInt(tag.getAttribute('data-beyo-setof'), 10);
      tag.classList.toggle('is-selected', fs.setOf && fs.setOf.has(v));
    });

    // IMPORTANT: синхронизировать range-слайдеры (они живут отдельно)
    root.querySelectorAll('[data-beyo-range]').forEach(function (groupEl) {
      updateRangeProgress(groupEl);
    });
  }

  function attachImageReveal(img) {
    if (!img || img.dataset.revealBound) return;
    img.dataset.revealBound = '1';

    function mark() {
      img.classList.add('is-loaded');
      var wrap = img.closest('.beyo-product-card__image-wrapper');
      if (wrap) wrap.classList.add('has-loaded');
    }

    if (img.complete && img.naturalWidth > 0) {
      mark();
      return;
    }

    img.addEventListener('load', mark, { once: true });
    img.addEventListener('error', function () {
      var wrap = img.closest('.beyo-product-card__image-wrapper');
      if (wrap) wrap.classList.add('has-loaded');
    }, { once: true });
  }


  function initCardSliders(container) {
    var sliders = container.querySelectorAll('[data-beyo-card-slider]');
    sliders.forEach(function (sliderEl) {
      var track = sliderEl.querySelector('.beyo-product-card__slides');
      var slides = sliderEl.querySelectorAll('.beyo-product-card__slide');
      var dots = sliderEl.querySelectorAll('.beyo-slider-dot');
      var prevBtn = sliderEl.querySelector('[data-beyo-slider-prev]');
      var nextBtn = sliderEl.querySelector('[data-beyo-slider-next]');

      if (!track || !slides.length) return;

      if (slides.length <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        if (dots.length) {
          dots.forEach(function (d) { d.style.display = 'none'; });
        }
        var img0 = slides[0].querySelector('img');
        if (img0) attachImageReveal(img0);
        if (img0 && img0.getAttribute('data-beyo-src') && !img0.dataset.loaded) {
          img0.src = img0.getAttribute('data-beyo-src');
          img0.dataset.loaded = '1';
        }
        return;
      }

      var current = 0;

      function ensureLoaded(index) {
        var slide = slides[index];
        if (!slide) return;
        var img = slide.querySelector('img');
        if (!img) return;

        var dataSrc = img.getAttribute('data-beyo-src');
        if (dataSrc && !img.dataset.loaded) {
          attachImageReveal(img);
          img.src = dataSrc;
          img.dataset.loaded = '1';
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        } else {
          attachImageReveal(img);
        }
      }

      function update() {
        ensureLoaded(current);

        track.style.transform = 'translateX(' + (-current * 100) + '%)';

        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
        });

        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
        });

        if (prevBtn) prevBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
        if (nextBtn) nextBtn.style.visibility = current === slides.length - 1 ? 'hidden' : 'visible';
      }

      function show(index) {
        if (index < 0) index = 0;
        if (index >= slides.length) index = slides.length - 1;
        current = index;
        update();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          show(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          show(current + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          var idx = Number(dot.getAttribute('data-beyo-slider-dot'));
          if (!isNaN(idx)) show(idx);
        });
      });

      var startX = null;
      var isDown = false;

      function onStart(clientX) {
        isDown = true;
        startX = clientX;
      }

      function onEnd(clientX) {
        if (!isDown || startX == null) return;
        isDown = false;

        var diff = clientX - startX;
        var threshold = 40; // px

        if (diff > threshold) {
          show(current - 1);
        } else if (diff < -threshold) {
          show(current + 1);
        }
      }

      track.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        onStart(e.touches[0].clientX);
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        onEnd(e.changedTouches[0].clientX);
      });

      track.addEventListener('mousedown', function (e) {
        onStart(e.clientX);
      });

      window.addEventListener('mouseup', function (e) {
        if (!isDown) return;
        onEnd(e.clientX);
      });

      show(0);
    });
  }

  function renderProducts(root) {
    if (!productsState) return;

    var grid = root.querySelector('[data-beyo-products-grid]');
    var pagination = root.querySelector('[data-beyo-pagination]');
    var countEl = root.querySelector('[data-beyo-products-count]');

    if (!grid) return;

    // helper: build URL for a given page using short keys
    function buildPageUrl(page) {
      var sp = new URLSearchParams(window.location.search);

      // page
      if (page > 1) sp.set('page', String(page));
      else sp.delete('page');

      // sort
      if (productsState.sortBy && productsState.sortBy !== 'featured') sp.set('sort', productsState.sortBy);
      else sp.delete('sort');

      // filters
      function setNum(key, val) {
        if (val == null || isNaN(val)) sp.delete(key);
        else sp.set(key, String(val));
      }
      function setSet(key, set) {
        if (!set || set.size === 0) sp.delete(key);
        else sp.set(key, Array.from(set).join(','));
      }

      var fs = filtersState || {};

      setNum('priceMin', fs.priceMin);
      setNum('priceMax', fs.priceMax);

      setNum('heightMin', fs.heightMin);
      setNum('heightMax', fs.heightMax);

      setNum('widthMin', fs.widthMin);
      setNum('widthMax', fs.widthMax);

      setNum('depthMin', fs.depthMin);
      setNum('depthMax', fs.depthMax);

      setNum('seatHeightMin', fs.seatHeightMin);
      setNum('seatHeightMax', fs.seatHeightMax);

      setSet('wood', fs.wood);
      setSet('setOf', fs.setOf);

      var qs = sp.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    if (!productsState.all || !productsState.all.length) {
      grid.innerHTML = '<div class="beyo-products-empty">' + t('products.no_products','No products') + '</div>';
      if (countEl) countEl.textContent = t('products.zero_items','0 items');
      if (pagination) pagination.innerHTML = '';
      return;
    }

    // No-results UI (оставляю твою логику как есть)
    if (
      productsState.filtered !== null &&
      Array.isArray(productsState.filtered) &&
      productsState.filtered.length === 0
    ) {
      if (countEl) countEl.textContent = t('products.zero_items','0 items');
      if (pagination) pagination.innerHTML = '';

      grid.classList.add('beyo-products-grid--no-results');
      grid.innerHTML = `
        <div class="beyo-no-results-full">
          <div class="beyo-no-results">
            <h2 class="beyo-no-results__title">Didn’t find the right piece?</h2>
            <p class="beyo-no-results__subtitle">
              Leave your details and we’ll help you find a similar piece or notify you when new pieces arrive.
            </p>

            <form class="no-results-form">
              <div class="no-results-form__filters">
                <div class="no-results-form__filters-title">Your current filters</div>
                <div class="no-results-form__chips" data-beyo-noresults-filters></div>
              </div>

              <div class="no-results-form__grid">
                <div class="no-results-form__field">
                  <label for="NoResultsName">${t('no_results.name','Name')}</label>
                  <input id="NoResultsName" name="name" type="text" required />
                </div>

                <div class="no-results-form__field">
                  <label for="NoResultsPhone">Phone</label>
                  <input id="NoResultsPhone" name="phone" type="tel" required />
                </div>

                <div class="no-results-form__field">
                  <label for="NoResultsEmail">E-mail (optional)</label>
                  <input id="NoResultsEmail" name="email" type="email" />
                </div>

                <div class="no-results-form__field">
                  <label for="NoResultsTimeFrame">${t('no_results.time_frame','Time frame')}</label>
                  <select id="NoResultsTimeFrame" name="timeFrame">
                    <option value="">${t('no_results.select','Select…')}</option>
                    <option value="within-2-weeks">${t('no_results.within_2_weeks','Within 2 weeks')}</option>
                    <option value="within-1-month">${t('no_results.within_1_month','Within 1 month')}</option>
                    <option value="within-3-months">${t('no_results.within_3_months','Within 3 months')}</option>
                    <option value="within-6-months">${t('no_results.within_6_months','Within 6 months')}</option>
                    <option value="within-1-year">${t('no_results.within_1_year','Within 1 year')}</option>
                    <option value="anytime">${t('no_results.anytime','Anytime')}</option>
                  </select>
                </div>

                <div class="no-results-form__field no-results-form__field--full">
                  <label for="NoResultsMessage">${t('no_results.message','Message')}</label>
                  <textarea id="NoResultsMessage" name="message" rows="4"></textarea>
                </div>
              </div>

              <div class="no-results-form__actions">
                <button type="submit" class="no-results-form__submit">${t('no_results.send','Send Request')}</button>
              </div>

              <div class="no-results-form__success" style="display:none;"></div>
              <div class="no-results-form__errors"></div>
            </form>
          </div>
        </div>
      `;

      buildNoResultsFilterSummary(root);
      initNoResultsForm(root);
      return;
    }

    var snapshot = getPagedProducts(productsState);

    if (countEl) {
      grid.classList.remove('beyo-products-grid--no-results');
      countEl.textContent = snapshot.totalItems + ' ' + t('products.items','items');
    }

    if (!snapshot.items.length) {
      grid.innerHTML = '<div class="beyo-products-empty">' + t('products.no_items_match','No items match your filters.') + '</div>';
      if (pagination) pagination.innerHTML = '';
      return;
    }

    var html = snapshot.items.map(function (p) {
      var discount = null;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        discount = Math.round(100 - (p.price / p.compare_at_price * 100));
      }

      var badgeHtml = '';
      if (p.sold_out) {
        badgeHtml += '<div class="beyo-product-card__pill beyo-product-card__pill--soldout">' + t('badges.sold_out','Sold Out') + '</div>';
      }
      if (discount !== null && discount > 0) {
        badgeHtml += '<div class="beyo-product-card__pill beyo-product-card__pill--discount">-' + discount + '%</div>';
      }
      if (p.tags && p.tags.includes('RESERVED')) {
        badgeHtml += '<div class="beyo-product-card__pill beyo-product-card__pill--reserved">' + t('badges.reserved','Reserved') + '</div>';
      }

      var priceHtml;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml =
          '<div class="beyo-product-card__price-main beyo-product-card__price-main--sale">' + formatMoney(p.price) + '</div>' +
          '<div class="beyo-product-card__price-compare">' + formatMoney(p.compare_at_price) + '</div>';
      } else {
        priceHtml = '<div class="beyo-product-card__price-main">' + formatMoney(p.price) + '</div>';
      }

      return (
        '<article class="beyo-product-card">' +
          '<a class="beyo-product-card__link" href="' + p.url + '">' +

            '<div class="beyo-product-card__image-wrapper" data-beyo-card-slider>' +
              (badgeHtml ? '<div class="beyo-product-card__badge-col">' + badgeHtml + '</div>' : '') +
              '<div class="beyo-product-card__slides">' +
                p.images.map(function (imgUrl, idx) {
                  var safeTitle = p.title.replace(/"/g, '&quot;');
                  return (
                    '<div class="beyo-product-card__slide' + (idx === 0 ? ' is-active' : '') + '" data-slide-index="' + idx + '">' +
                      '<img class="beyo-product-card__image" ' +
                        'data-beyo-src="' + imgUrl + '" ' +
                        'alt="' + safeTitle + '" ' +
                        'loading="lazy" decoding="async">' +
                    '</div>'
                  );
                }).join('') +
              '</div>' +
              '<button type="button" class="beyo-slider-nav beyo-slider-nav--prev" data-beyo-slider-prev>&lsaquo;</button>' +
              '<button type="button" class="beyo-slider-nav beyo-slider-nav--next" data-beyo-slider-next>&rsaquo;</button>' +
              '<div class="beyo-slider-dots">' +
                p.images.map(function (_, idx) {
                  return '<button type="button" class="beyo-slider-dot' +
                    (idx === 0 ? ' is-active' : '') +
                    '" data-beyo-slider-dot="' + idx + '"></button>';
                }).join('') +
              '</div>' +
            '</div>' +

            '<div class="beyo-product-card__body">' +
              '<h3 class="beyo-product-card__title">' + p.title + '</h3>' +
              '<div class="beyo-product-card__price-row">' +
                priceHtml +
              '</div>' +
            '</div>' +

          '</a>' +
        '</article>'
      );
    }).join('');

    grid.innerHTML = html || '<div class="beyo-products-empty">No products</div>';
    initLazyImages(grid);
    initCardSliders(grid);

    // -------------------------
    // PAGINATION (SEO links)
    // -------------------------
    if (pagination) {
      if (snapshot.totalPages <= 1) {
        pagination.innerHTML = '';
      } else {
        var pagHtml = '';
        var total = snapshot.totalPages;
        var current = snapshot.currentPage;

        function pageLink(page, label, active) {
          var href = buildPageUrl(page);
          return '<a class="beyo-page-link' +
            (active ? ' is-active' : '') +
            '" data-beyo-page="' + page + '" href="' + href + '">' + label + '</a>';
        }

        // Prev
        if (current > 1) {
          pagHtml += pageLink(current - 1, 'Prev', false);
        }

        if (total <= 5) {
          for (var i = 1; i <= total; i++) {
            pagHtml += pageLink(i, String(i), i === current);
          }
        } else {
          pagHtml += pageLink(1, '1', current === 1);

          if (current > 3) {
            pagHtml += '<span class="beyo-page-ellipsis">…</span>';
          }

          var start = Math.max(2, current - 1);
          var end = Math.min(total - 1, current + 1);
          for (var p = start; p <= end; p++) {
            pagHtml += pageLink(p, String(p), p === current);
          }

          if (current < total - 2) {
            pagHtml += '<span class="beyo-page-ellipsis">…</span>';
          }

          pagHtml += pageLink(total, String(total), current === total);
        }

        // Next
        if (current < total) {
          pagHtml += pageLink(current + 1, 'Next', false);
        }

        pagination.innerHTML = pagHtml;

        // SPA click (but allow new tab etc.)
        pagination.onclick = function (e) {
          var a = e.target.closest('a[data-beyo-page]');
          if (!a) return;

          // allow: ctrl/cmd/shift click, middle click
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

          e.preventDefault();

          var page = Number(a.getAttribute('data-beyo-page'));
          if (isNaN(page)) return;

          productsState.currentPage = page;

          // IMPORTANT: URL update (pushState)
          if (typeof writeUrlState === 'function') {
            writeUrlState(productsState, filtersState, false);
          }

          renderProducts(root);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
      }
    }
  }

  function buildSetOfFilter(root, products) {
    var list = root.querySelector('[data-beyo-setof-list]');
    var panel = root.querySelector('[data-beyo-filter-panel="setof"]');
    var chip = root.querySelector('[data-beyo-filter-chip="setof"]');

    console.log('[SET OF DEBUG] products:', products);
    console.log('[SET OF DEBUG] raw set_of values:', (products || []).map(function (p) { return p && p.set_of; }));

    if (!list) {
      console.log('[SET OF DEBUG] no list found');
      return;
    }

    var values = Array.from(new Set(
      (products || [])
        .map(function (p) { return p && p.set_of; })
        .filter(function (v) { return v != null && !isNaN(v) && v > 0; })
    )).sort(function (a, b) { return a - b; });

    console.log('[SET OF DEBUG] final values:', values);
    console.log('[SET OF DEBUG] panel:', panel);
    console.log('[SET OF DEBUG] chip:', chip);

    if (!values.length) {
      list.innerHTML = '';
      if (panel) {
        panel.style.display = 'none';
        panel.classList.remove('is-visible');
      }
      if (chip) {
        chip.style.display = 'none';
        chip.classList.remove('is-active');
      }
      return;
    }

    if (panel) panel.style.display = '';
    if (chip) chip.style.display = '';

    list.innerHTML = values.map(function (value) {
      var label = value >= 10
      ? '10+'
      : t('filters.set_of_value', 'Set of {value}').replace('{value}', String(value));
      return ''
        + '<button type="button" class="beyo-filter-tag" data-beyo-setof="' + value + '">'
        + label
        + '</button>';
    }).join('');
  }

  function buildNoResultsFilterSummary(root) {
    var box = root.querySelector('[data-beyo-noresults-filters]');
    if (!box || !filtersState) return;

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    var chips = [];

    function pushChip(label) {
      if (label) chips.push(escapeHtml(label));
    }
    if (filtersState.priceMin != null || filtersState.priceMax != null) {
      var parts = [];
      if (filtersState.priceMin != null) {
        parts.push('from ' + formatMoney(filtersState.priceMin));
      }
      if (filtersState.priceMax != null) {
        parts.push('to ' + formatMoney(filtersState.priceMax));
      }
      pushChip('Price: ' + parts.join(' '));
    }
    function dimLabel(name, min, max, unit) {
      if (min == null && max == null) return null;
      var segs = [];
      if (min != null) segs.push('from ' + min + unit);
      if (max != null) segs.push('to ' + max + unit);
      return name + ': ' + segs.join(' ');
    }

    pushChip(dimLabel('Height', filtersState.heightMin, filtersState.heightMax, ' cm'));
    pushChip(dimLabel('Width',  filtersState.widthMin,  filtersState.widthMax,  ' cm'));
    pushChip(dimLabel('Depth',  filtersState.depthMin,  filtersState.depthMax,  ' cm'));
    if (filtersState.wood && filtersState.wood.size > 0) {
      var woods = Array.from(filtersState.wood).map(function (w) {
        return w.split(' ').map(function (part) {
          part = part.trim();
          if (!part) return '';
          return part.charAt(0).toUpperCase() + part.slice(1);
        }).join(' ');
      });
      pushChip('Wood: ' + woods.join(', '));
    }
    if (filtersState.setOf && filtersState.setOf.size > 0) {
      var setOfValues = Array.from(filtersState.setOf).sort(function (a, b) { return a - b; });
      pushChip(
        t('no_results.set_of', 'Set of: {values}')
          .replace('{values}', setOfValues.join(', '))
      );
    }
    if (!chips.length) {
      box.innerHTML =
        '<span class="no-results-chip no-results-chip--empty">No filters selected</span>';
    } else {
      box.innerHTML = chips
        .map(function (c) {
          return '<span class="no-results-chip">' + c + '</span>';
        })
        .join('');
    }
  }

  var beyoLazyIO = null;

  function initLazyImages(container) {
    if (!container) return;

    var imgs = container.querySelectorAll('img[data-beyo-src]:not([data-beyo-observed])');
    if (!imgs.length) return;

    function load(img) {
      if (!img || img.dataset.loaded) return;
      var src = img.getAttribute('data-beyo-src');
      if (!src) return;

      img.dataset.loaded = '1';
      attachImageReveal(img);
      img.src = src;
    }

    if (!('IntersectionObserver' in window)) {
      imgs.forEach(load);
      return;
    }

    if (!beyoLazyIO) {
      beyoLazyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var img = entry.target;
          load(img);
          beyoLazyIO.unobserve(img);
        });
      }, {
        root: null,
        rootMargin: '500px 0px',
        threshold: 0.01
      });
    }

    imgs.forEach(function (img) {
      img.dataset.beyoObserved = '1';
      beyoLazyIO.observe(img);
    });
  }

  function initNoResultsForm(root) {
    var form = root.querySelector('.no-results-form');
    if (!form) return;

    var msgEl = form.querySelector('#NoResultsMessage');
    if (msgEl && !msgEl.value) {
      var collectionTitle = window.__collectionTitle || document.title || '';
      var path = window.location.pathname;
      msgEl.placeholder =
        'Collection: ' + collectionTitle + ' (' + path + ')\n' +
        'Tell us what you were looking for: dimensions, wood type, colour, style, etc.';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var successBox = form.querySelector('.no-results-form__success');
      var errorBox = form.querySelector('.no-results-form__errors');

      if (btn) {
        btn.disabled = true;
        btn.textContent = t('no_results.sending','Sending...');
      }
      if (errorBox) errorBox.innerHTML = '';
      if (successBox) successBox.style.display = 'none';

      var name = form.querySelector('#NoResultsName')?.value?.trim() || null;
      var phone = form.querySelector('#NoResultsPhone')?.value?.trim() || null;
      var email = form.querySelector('#NoResultsEmail')?.value?.trim() || null;
      var message = msgEl ? (msgEl.value || '').trim() : null;

      var timeFrame = form.querySelector('#NoResultsTimeFrame')?.value || null;

      var fs = filtersState || {};
      var woodTypes = [];
      if (fs.wood && fs.wood.size > 0) {
        woodTypes = Array.from(fs.wood);
      }
      var setOfValues = [];
      if (fs.setOf && fs.setOf.size > 0) {
        setOfValues = Array.from(fs.setOf).sort(function (a, b) { return a - b; });
      }
      
      var payload = {
        name: name,
        phone: phone,
        email: email,
        message: message,

        timeFrame: timeFrame,

        collection: window.__collectionTitle || document.title || '',
        currentUrl: window.location.pathname + window.location.search,

        heightMin: fs.heightMin ?? null,
        heightMax: fs.heightMax ?? null,
        widthMin: fs.widthMin ?? null,
        widthMax: fs.widthMax ?? null,
        depthMin: fs.depthMin ?? null,
        depthMax: fs.depthMax ?? null,

        priceMin: fs.priceMin ?? null,
        priceMax: fs.priceMax ?? null,

        woodTypes: woodTypes,
        setOf: setOfValues
      };

      console.log('Sending NoResults payload:', payload);

      fetch('https://booking.beyovintage.se/api/no-results/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Server returned ' + response.status);
          }

          if (successBox) {
            successBox.textContent = t('no_results.success','Thank you! We will contact you soon.');
            successBox.style.display = 'block';
          }

          form.reset();
        })
        .catch(function (err) {
          console.error(err);
          if (errorBox) {
            errorBox.innerHTML =
              '<div class="no-results-form__error">' + t('no_results.failed','Failed to send. Try again later.') + '</div>';
          }
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = t('no_results.send', 'Send Request');
          }
        });
    });
  }

  function initSort(root) {
    var select = root.querySelector('[data-beyo-sort]');
    if (!select) return;

    select.addEventListener('change', function () {
      var val = select.value;
      switch (val) {
        case 'best-selling':
        case 'title-asc':
        case 'title-desc':
        case 'price-asc':
        case 'price-desc':
        case 'date-asc':
        case 'date-desc':
        case 'featured':
          productsState.sortBy = val;
          break;
        default:
          productsState.sortBy = 'featured';
          break;
      }
      productsState.currentPage = 1;
      writeUrlState(productsState, filtersState, false);
      renderProducts(root);
    });
  }

  /* ============================
   * INIT
   * ============================ */

  function capitalizeLabel(key) {
    return key.split(' ').map(function (part) {
      part = part.trim();
      if (!part) return '';
      return part.charAt(0).toUpperCase() + part.slice(1);
    }).join(' ');
  }

  function buildWoodFilter(root, products) {
    var container = root.querySelector('[data-beyo-wood-list]');
    if (!container) return;

    container.innerHTML = '';

    var map = new Map();

    products.forEach(function (p) {
      (p.wood || []).forEach(function (w) {
        var key = String(w || '').toLowerCase().trim();
        if (!key) return;
        if (!map.has(key)) {
          map.set(key, capitalizeLabel(key));
        }
      });
    });

    var entries = Array.from(map.entries());
    if (!entries.length) {
      container.innerHTML = '<div class="beyo-filter-panel__hint">No wood types available.</div>';
      return;
    }

    var maxVisible = 5;
    entries.forEach(function (pair, index) {
      var value = pair[0];
      var label = pair[1];

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'beyo-filter-tag' + (index >= maxVisible ? ' beyo-filter-tag--extra' : '');
      btn.setAttribute('data-beyo-wood', value);
      btn.textContent = label;
      container.appendChild(btn);
    });

    if (entries.length > maxVisible) {
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'beyo-filter-tag beyo-filter-tag--more';
      moreBtn.textContent = 'Show more';
      moreBtn.setAttribute('data-expanded', 'false');

      moreBtn.addEventListener('click', function () {
        var expanded = moreBtn.getAttribute('data-expanded') === 'true';
        var extra = container.querySelectorAll('.beyo-filter-tag--extra');
        extra.forEach(function (el) {
          el.style.display = expanded ? 'none' : 'flex';
        });
        moreBtn.textContent = expanded ? 'Show more' : 'Show less';
        moreBtn.setAttribute('data-expanded', expanded ? 'false' : 'true');
      });

      container.appendChild(moreBtn);

      container.querySelectorAll('.beyo-filter-tag--extra').forEach(function (el) {
        el.style.display = 'none';
      });
    }
  }

  function initBeyoFilters() {
    console.log('[BEYO FILTERS] DOMContentLoaded');

    var root = document.getElementById('beyo-collection-root');
    if (!root) {
      console.log('[BEYO FILTERS] #beyo-collection-root not found');
      return;
    }

    var collectionHandle = root.getAttribute('data-collection-handle') || null;
    var isSeating = root.getAttribute('data-beyo-seating') === '1';
    var pageSize = parseInt(root.getAttribute('data-page-size') || '12', 10);
    if (!pageSize || pageSize < 1) pageSize = 12;

    var liquidSort = root.getAttribute('data-sort-by') || 'manual';
    function mapShopifySortToBeyo(key) {
      switch (key) {
        case 'best-selling': return 'best-selling';
        case 'title-ascending': return 'title-asc';
        case 'title-descending': return 'title-desc';
        case 'price-ascending': return 'price-asc';
        case 'price-descending': return 'price-desc';
        case 'created-ascending': return 'date-asc';
        case 'created-descending': return 'date-desc';
        default: return 'featured';
      }
    }
    var initialSortKey = mapShopifySortToBeyo(liquidSort);

    console.log('[BEYO FILTERS] collection handle:', collectionHandle, 'pageSize:', pageSize, 'sort:', initialSortKey);
    root.innerHTML = `
      <div class="container--large">
        <div class="beyo-collection">
          <div class="beyo-collection__layout">

            <aside class="beyo-filters">
              <div class="beyo-filters__header">
                <div class="beyo-filters__title" data-beyo-i18n="filters.title">Filters</div>
                <button type="button" class="beyo-filters__clear" data-beyo-i18n="filters.clear_all">Clear all</button>
              </div>

              <div class="beyo-filters__chips">
                <button type="button" class="beyo-filter-chip" data-beyo-filter-chip="price" data-beyo-i18n="filters.price">Price</button>
                <button type="button" class="beyo-filter-chip" data-beyo-filter-chip="wood" data-beyo-i18n="filters.wood">Wood type</button>
                ${isSeating ? `
                  <button type="button" class="beyo-filter-chip" data-beyo-filter-chip="setof" data-beyo-i18n="filters.set_of">Set of</button>
                ` : ``}
                <button type="button" class="beyo-filter-chip" data-beyo-filter-chip="size" data-beyo-i18n="filters.size">Size</button>
                <button type="button" class="beyo-filter-chip beyo-filter-chip--primary" data-beyo-filter-chip="all" data-beyo-i18n="filters.all">All filters</button>
              </div>

              <div class="beyo-filters__backdrop" data-beyo-sheet-backdrop></div>

              <div class="beyo-filters__body" data-beyo-filters-body>
                <div class="beyo-filters__sheet-header">
                  <div class="beyo-filters__sheet-title" data-beyo-i18n="filters.title">Filters</div>
                  <button type="button" class="beyo-filters__sheet-close" data-beyo-i18n="filters.done">Done</button>
                </div>

                <!-- PRICE -->
                <section class="beyo-filter-panel" data-beyo-filter-panel="price">
                  <div class="beyo-filter-panel__title" data-beyo-i18n="filters.price_range">Price Range</div>

                  <div class="beyo-range"
                      data-beyo-range="price"
                      data-min="0"
                      data-max="100000"
                      data-step="100">
                    <div class="beyo-range__track">
                      <div class="beyo-range__progress"></div>
                    </div>
                    <input type="range" class="beyo-range__input beyo-range__input--min" />
                    <input type="range" class="beyo-range__input beyo-range__input--max" />
                  </div>

                  <div class="beyo-filter-panel__row">
                    <input type="number"
                          class="beyo-filter-input beyo-filter-input--small"
                          data-beyo-range-min-input="price"
                          data-beyo-i18n-placeholder="filters.min"
                          placeholder="Min" />
                    <span>–</span>
                    <input type="number"
                          class="beyo-filter-input beyo-filter-input--small"
                          data-beyo-range-max-input="price"
                          data-beyo-i18n-placeholder="filters.max"
                          placeholder="Max" />
                  </div>
                </section>

                <!-- WOOD TYPE -->
                <section class="beyo-filter-panel" data-beyo-filter-panel="wood">
                  <div class="beyo-filter-panel__title" data-beyo-i18n="filters.wood">Wood Type</div>
                  <div class="beyo-filter-taglist" data-beyo-wood-list>
                    <!-- опции wood будут сгенерированы из данных Storefront -->
                  </div>
                </section>

                <!-- SIZE -->
                <section class="beyo-filter-panel" data-beyo-filter-panel="size">
                  <div class="beyo-filter-panel__title" data-beyo-i18n="filters.size">Size</div>

                  <div class="beyo-filter-dim">
                    <div class="beyo-filter-dim__label-row">
                      <span class="beyo-filter-dim-label" data-beyo-i18n="filters.height">Height (cm)</span>
                    </div>

                    <div class="beyo-range"
                        data-beyo-range="height"
                        data-min="0"
                        data-max="350"
                        data-step="1">
                      <div class="beyo-range__track">
                        <div class="beyo-range__progress"></div>
                      </div>
                      <input type="range" class="beyo-range__input beyo-range__input--min" />
                      <input type="range" class="beyo-range__input beyo-range__input--max" />
                    </div>

                    <div class="beyo-filter-panel__row">
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-min-input="height"
                            data-beyo-i18n-placeholder="filters.min"
                            placeholder="Min" />
                      <span>–</span>
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-max-input="height"
                            data-beyo-i18n-placeholder="filters.max"
                            placeholder="Max" />
                    </div>
                  </div>

                  <div class="beyo-filter-dim">
                    <div class="beyo-filter-dim__label-row">
                      <span class="beyo-filter-dim-label" data-beyo-i18n="filters.width">Width (cm)</span>
                    </div>

                    <div class="beyo-range"
                        data-beyo-range="width"
                        data-min="0"
                        data-max="350"
                        data-step="1">
                      <div class="beyo-range__track">
                        <div class="beyo-range__progress"></div>
                      </div>
                      <input type="range" class="beyo-range__input beyo-range__input--min" />
                      <input type="range" class="beyo-range__input beyo-range__input--max" />
                    </div>

                    <div class="beyo-filter-panel__row">
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-min-input="width"
                            data-beyo-i18n-placeholder="filters.min"
                            placeholder="Min" />
                      <span>–</span>
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-max-input="width"
                            data-beyo-i18n-placeholder="filters.max"
                            placeholder="Max" />
                    </div>
                  </div>

                  <div class="beyo-filter-dim">
                    <div class="beyo-filter-dim__label-row">
                      <span class="beyo-filter-dim-label" data-beyo-i18n="filters.depth">Depth (cm)</span>
                    </div>

                    <div class="beyo-range"
                        data-beyo-range="depth"
                        data-min="0"
                        data-max="350"
                        data-step="1">
                      <div class="beyo-range__track">
                        <div class="beyo-range__progress"></div>
                      </div>
                      <input type="range" class="beyo-range__input beyo-range__input--min" />
                      <input type="range" class="beyo-range__input beyo-range__input--max" />
                    </div>

                    <div class="beyo-filter-panel__row">
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-min-input="depth"
                            data-beyo-i18n-placeholder="filters.min"
                            placeholder="Min" />
                      <span>–</span>
                      <input type="number"
                            class="beyo-filter-input beyo-filter-input--small"
                            data-beyo-range-max-input="depth"
                            data-beyo-i18n-placeholder="filters.max"
                            placeholder="Max" />
                    </div>
                  </div>
                  ${isSeating ? `
                    <div class="beyo-filter-dim">
                      <div class="beyo-filter-dim__label-row">
                        <span class="beyo-filter-dim-label" data-beyo-i18n="filters.seat_height">Seat height (cm)</span>
                      </div>

                      <div class="beyo-range"
                          data-beyo-range="seatHeight"
                          data-min="0"
                          data-max="350"
                          data-step="1">
                        <div class="beyo-range__track">
                          <div class="beyo-range__progress"></div>
                        </div>
                        <input type="range" class="beyo-range__input beyo-range__input--min" />
                        <input type="range" class="beyo-range__input beyo-range__input--max" />
                      </div>

                      <div class="beyo-filter-panel__row">
                        <input type="number"
                              class="beyo-filter-input beyo-filter-input--small"
                              data-beyo-range-min-input="seatHeight"
                              data-beyo-i18n-placeholder="filters.min"
                              placeholder="Min" />
                        <span>–</span>
                        <input type="number"
                              class="beyo-filter-input beyo-filter-input--small"
                              data-beyo-range-max-input="seatHeight"
                              data-beyo-i18n-placeholder="filters.max"
                              placeholder="Max" />
                      </div>
                    </div>
                  ` : ``}
                </section>
                ${isSeating ? `
                    <section class="beyo-filter-panel" data-beyo-filter-panel="setof">
                      <div class="beyo-filter-panel__title" data-beyo-i18n="filters.set_of">Set of</div>
                      <div class="beyo-filter-taglist" data-beyo-setof-list></div>
                    </section>
                  ` : ``}
              </div>
            </aside>

            <div class="beyo-collection__products">
              <div class="beyo-products-header">
                <button type="button"
                        class="beyo-filters-toggle"
                        data-beyo-filters-toggle
                        data-beyo-i18n="filters.hide">
                  Hide filters
                </button>

                <div class="beyo-products-count" data-beyo-products-count data-beyo-i18n="products.loading">Loading…</div>

                <div class="beyo-products-sort">
                  <label class="beyo-products-sort__label" for="beyo-sort" data-beyo-i18n="sort.label">Sort by</label>
                  <select id="beyo-sort" class="beyo-products-sort__select" data-beyo-sort>
                    <option value="featured" data-beyo-i18n="sort.featured">Featured</option>
                    <option value="best-selling" data-beyo-i18n="sort.best_selling">Best selling</option>
                    <option value="title-asc" data-beyo-i18n="sort.title_asc">Alphabet A–Z</option>
                    <option value="title-desc" data-beyo-i18n="sort.title_desc">Alphabet Z–A</option>
                    <option value="price-asc" data-beyo-i18n="sort.price_asc">Price low to high</option>
                    <option value="price-desc" data-beyo-i18n="sort.price_desc">Price high to low</option>
                    <option value="date-asc" data-beyo-i18n="sort.date_asc">Date old to new</option>
                    <option value="date-desc" data-beyo-i18n="sort.date_desc">Date new to old</option>
                  </select>
                </div>
              </div>

              <div class="beyo-products-grid" data-beyo-products-grid>
                <div class="beyo-products-loader" data-beyo-products-loader>
                  <div class="beyo-products-loader__box">
                    <div class="beyo-products-loader__spinner"></div>
                    <div class="beyo-products-loader__text" data-beyo-i18n="products.loading">
                      Loading products…
                    </div>
                  </div>
                </div>
              </div>

              <div class="beyo-pagination" data-beyo-pagination></div>
            </div>

          </div>
        </div>
      </div>
    `;
    showProductsLoader(root);
    applyI18n(root);
    filtersState = {
      priceMin: null,
      priceMax: null,
      heightMin: null,
      heightMax: null,
      widthMin: null,
      widthMax: null,
      depthMin: null,
      depthMax: null,
      seatHeightMin: null,
      seatHeightMax: null,
      wood: new Set(),
      setOf: new Set()
    };

    function readFiltersFromUI() {
      function getNum(selector) {
        var el = root.querySelector(selector);
        if (!el) return null;
        var v = parseFloat(el.value);
        return isNaN(v) ? null : v;
      }

      filtersState.priceMin = getNum('[data-beyo-range-min-input="price"]');
      filtersState.priceMax = getNum('[data-beyo-range-max-input="price"]');

      filtersState.heightMin = getNum('[data-beyo-range-min-input="height"]');
      filtersState.heightMax = getNum('[data-beyo-range-max-input="height"]');

      filtersState.widthMin = getNum('[data-beyo-range-min-input="width"]');
      filtersState.widthMax = getNum('[data-beyo-range-max-input="width"]');

      filtersState.depthMin = getNum('[data-beyo-range-min-input="depth"]');
      filtersState.depthMax = getNum('[data-beyo-range-max-input="depth"]');

      if (isSeating) {
        filtersState.seatHeightMin = getNum('[data-beyo-range-min-input="seatHeight"]');
        filtersState.seatHeightMax = getNum('[data-beyo-range-max-input="seatHeight"]');
      } else {
        filtersState.seatHeightMin = null;
        filtersState.seatHeightMax = null;
      }

      var woodSet = new Set();
      root.querySelectorAll('[data-beyo-wood].is-selected').forEach(function (tag) {
        var val = (tag.getAttribute('data-beyo-wood') || tag.textContent || '').toLowerCase().trim();
        if (val) woodSet.add(val);
      });
      filtersState.wood = woodSet;

      var setOfSet = new Set();
      if (isSeating) {
        root.querySelectorAll('[data-beyo-setof].is-selected').forEach(function (tag) {
          var val = parseInt(tag.getAttribute('data-beyo-setof'), 10);
          if (!isNaN(val)) setOfSet.add(val);
        });
      }
      filtersState.setOf = setOfSet;
    }

    function applyFiltersAndRender() {
      if (!productsState || !productsState.all) return;

      readFiltersFromUI();

      function hasNumber(val) {
        return val != null && !isNaN(val);
      }

      var filtersActive =
        hasNumber(filtersState.priceMin) ||
        hasNumber(filtersState.priceMax) ||
        hasNumber(filtersState.heightMin) ||
        hasNumber(filtersState.heightMax) ||
        hasNumber(filtersState.widthMin)  ||
        hasNumber(filtersState.widthMax)  ||
        hasNumber(filtersState.depthMin)  ||
        hasNumber(filtersState.depthMax)  ||
        (isSeating && (hasNumber(filtersState.seatHeightMin) || hasNumber(filtersState.seatHeightMax))) ||
        (filtersState.wood && filtersState.wood.size > 0) ||
        (filtersState.setOf && filtersState.setOf.size > 0);

      if (filtersActive) {
        productsState.filtered = applyFilters(productsState.all);
      } else {
        productsState.filtered = null;
      }

      productsState.currentPage = 1;
      writeUrlState(productsState, filtersState, false);
      renderProducts(root);
    }

    onFiltersChange = applyFiltersAndRender;

    initFilterChips(root);
    root.querySelectorAll('[data-beyo-range]').forEach(initRange);
    initClearButton(root);
    initSort(root);
    initFiltersToggle(root);

    productsState = {
      all: [],
      filtered: null,
      sortBy: initialSortKey,
      pageSize: pageSize,
      currentPage: 1
    };

    var urlState = parseUrlState(isSeating);
    if (urlState.sort) {
      productsState.sortBy = urlState.sort;
    }
    filtersState = urlState.filters;
    applyFiltersToUI(root, filtersState, isSeating);
    productsState.currentPage = urlState.page || 1;

    var sortSelect = root.querySelector('[data-beyo-sort]');
    if (sortSelect) {
      sortSelect.value = productsState.sortBy;
    }

    if (!collectionHandle) {
      console.warn('[BEYO FILTERS] No collection handle, cannot load products');
      renderProducts(root);
      return;
    }

    window.addEventListener('popstate', function () {
      var st = parseUrlState(isSeating);
      if (st.sort) productsState.sortBy = st.sort;
      else productsState.sortBy = initialSortKey;
      filtersState = st.filters;
      applyFiltersToUI(root, filtersState, isSeating);
      if (productsState && productsState.all && productsState.all.length) {
        productsState.filtered = applyFilters(productsState.all);
      }
      productsState.currentPage = st.page || 1;
      renderProducts(root);
    });


    loadProductsFromStorefront(root, collectionHandle, 500)
      .then(function (products) {
        productsState.all = products || [];
        buildWoodFilter(root, productsState.all);
        initWoodTags(root);

        if (isSeating) {
          buildSetOfFilter(root, productsState.all);
          initSetOfTags(root);
          applyFiltersToUI(root, filtersState, isSeating);
        }

        applyFiltersAndRender();
        hideProductsLoader(root);
        document.documentElement.classList.add('beyo-js-enabled');
        document.documentElement.classList.add('beyo-ready');
      })
      .catch(function (err) {
        console.error('[BEYO FILTERS] Failed to load products', err);
        renderProducts(root);
        hideProductsLoader(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBeyoFilters);
  } else {
    initBeyoFilters();
  }
})();
